var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RemoveRowButton',{attrs:{"row-index":_vm.rowIndex,"canBeDeleted":_vm.canBeDeleted()}})}
var staticRenderFns = []

export { render, staticRenderFns }